import styled from "styled-components";

import { Dialog } from "@libraries/mui";

import { windowWidth } from "@styles/global";

interface IconContainerProps {
  color: string;
}

const Container = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 10px !important;
    min-width: 400px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }

  .MuiDialogContent-root {
    padding: 0px 24px;
  }

  #alertDialog-title {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const IconContainer = styled.div<IconContainerProps>`
  #alouu {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  svg {
    fill: ${({ color }) => color};
    margin-right: 16px;
    width: 32px;
    height: 32px;
  }
`;

const DialogActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  button {
    color: #9400ee;
  }
`;

export { Container, DialogActions, IconContainer };
